<template>
  <section>
    <p class="text-center pl-5 pr-5 pt-3"><q><em>{{ quote }}</em></q></p>
    <div class="d-flex justify-content-center mt-2">
      <h1 class="w-95 pt-2 pb-2 bg-color-grey rounded text-center text-white font-size-xxl">My insurance Details</h1>
    </div>
    <div class="ml-4 ml-md-4 ml-lg-5 w-90">
      <div class="d-flex justify-content-end">
        <div class="mb-2">
          <router-link to="/">
            <button type="button" class="btn btn-sm btn-outline-dark">
              <font-awesome-icon icon="plus" class="text-color-grey"/>
              <span>Add New Insurance</span>
            </button>
          </router-link>
        </div>
      </div>
      <div id="accordion" :key="item + index" v-for="(item, index) in data" class="mb-3">
        <app-insurance-view-auto v-if="item.typeinsurance === 'Auto'" :data="item" :index="index"></app-insurance-view-auto>
        <app-insurance-view-cyber v-if="item.typeinsurance === 'Cyber'" :data="item" :index="index"></app-insurance-view-cyber>
        <app-insurance-view-home v-if="item.typeinsurance === 'Home'" :data="item" :index="index"></app-insurance-view-home>
        <app-insurance-view-prize v-if="item.typeinsurance === 'Prize'" :data="item" :index="index"></app-insurance-view-prize>
      </div>
    </div>
  </section>
</template>

<script>
import InsuranceViewAuto from './shared/insurances/views/InsuranceViewAuto'
import InsuranceViewCyber from './shared/insurances/views/InsuranceViewCyber'
import InsuranceViewHome from './shared/insurances/views/InsuranceViewHome'
import InsuranceViewPrize from './shared/insurances/views/InsuranceViewPrize'

export default {
  name: 'InsuranceDetails',
  // Load components of all insurance types and display them conditionally
  components: {
    AppInsuranceViewAuto: InsuranceViewAuto,
    AppInsuranceViewCyber: InsuranceViewCyber,
    AppInsuranceViewHome: InsuranceViewHome,
    AppInsuranceViewPrize: InsuranceViewPrize
  },
  data () {
    return {
      quote: this.$store.state.quotes[Math.floor(Math.random() * this.$store.state.quotes.length)],
      data: null
    }
  },
  // Load all insurances details of logged in user
  created () {
    this.$store.dispatch('fetchInsuranceByUser')
      .then(data => {
        this.data = data
        console.log('User Insurance details fetched successfully !')
        console.log('Insurance data : ')
        console.log(data)
      })
      .catch(() => console.log('Failed to fetch user insurance !'))
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/InsuranceDetails.vue